settingImageModule = angular.module('image.setting', [])

settingImageModule.directive "imageSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", ($window, $timeout, $compile, $templateCache, ns) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  link: (scope, element, attrs, ngModel) ->
    widgetEl = angular.element("[data-block-id='#{attrs.widgetId}']")
    imageDefaultCap = widgetEl.find ".default-cap_image"

    scope.accordion = {
      show_style: false
    }

    widgetEl.find("a").click (event) ->
      event.preventDefault()

    onImageRender = ->
      return

    setImage = (newval) ->
      if newval.image_attributes.source_url
        if imageDefaultCap.length
          widgetEl.find(".strwimage").html "<img alt='#{newval.title}' class='strwimage__image' src='#{newval.image_attributes.source_url}' /><div class='strwimage__title' contenteditable='false' data-access='title'>#{newval.title}</div>"
        else
          widgetEl.find(".strwimage__image").attr "src", newval.image_attributes.source_url
        widgetEl.find(".strwimage__image").unbind "load"
        widgetEl.find(".strwimage__image").bind "load", onImageRender

    setStretch = (newval) ->
      image = widgetEl.find ".strwimage__image"
      if newval.image_attributes.stretch
        image.css({"width": "100%"})
      else
        image.css({"width": "auto"})

    setVisibility = (newval) ->
      if newval.show_title
        widgetEl.find(".strwimage__title").show()
      else
        widgetEl.find(".strwimage__title").hide()

    setStyles = (newval) ->
      widgetEl.find("img").css "border-radius", newval.style_attributes.borderRadius

    proccessImageEditing = (newval) ->
      setImage newval
      setStretch newval
      setVisibility newval
      setStyles newval

    listener = scope.$watch "data", (newval, oldval) ->
      proccessImageEditing newval
    , true

    scope.$on "$destroy", ->
      listener()
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/image/image.directive.coffee